import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
// Compatibility for bookmarked legacy URLs. Financing starts on an invoice.
export const ChoosePackage = () => _jsx(Navigate, { to: '/invoicing', replace: true });
